import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { API_POINTS } from "src/app/helpers/model/endpoint.model";
import { ApiService } from "src/app/helpers/services/api.service";
import { ToastService } from "src/app/helpers/services/toast.service";
import { ContactViewComponent } from "../contact-view/contact-view.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-contacts-list",
  templateUrl: "./contacts-list.component.html",
  styleUrls: ["./contacts-list.component.css"],
})
export class ContactsListComponent implements OnInit {
  users: any = [];
  loading = false;
  event: any;
  globalFilter: any;
  resdata: any;
  totalRecords: any = 0;
  datatableRowsVal = 10;
  rowPerPage: any = [10, 25, 50];
  cols: any;
  emptyMessage: string | undefined;
  modelTitle: string | undefined;
  modelMsg: string | undefined;
  endpoint: any = API_POINTS;
  data: any;
  userData: any = {};
  addImportContactPopup = false;
  id: any;
  deleteId: any;
  type: any;
  constructor(
    public api: ApiService,
    private router: Router,
    private toast: ToastService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal,
  ) {}

  ngAfterViewChecked() {
    this.cdref.detectChanges();
  }

  ngOnInit() {
    setTimeout(() => {
      this.emptyMessage = "No Records Found";
      this.cols = [
        {
          colName: "Sr.No",
          isSort: true,
          colWidth: "9%",
          sortField: "srNo",
        },
        {
          isSort: true,
          colName: "Name",
          colWidth: "12%",
          sortField: "firstName",
        },
        {
          isSort: true,
          colName: "Title",
          colWidth: "14%",
          sortField: "title",
        },
        {
          isSort: false,
          colName: "Account Name",
          colWidth: "15%",
        },
        {
          isSort: true,
          colName: "Email",
          colWidth: "10%",
          sortField: "emailAddress",
        },
        {
          isSort: true,
          colName: "Office Phone",
          colWidth: "15%",
          sortField: "officePhone",
        },
        {
          isSort: false,
          colName: "Date Created",
          colWidth: "12%",
        },
        {
          colName: "Actions",
          isSort: false,
          colWidth: "20%",
        },
      ];
    });
  }

  onCreateContact() {
    this.router.navigate(["contact/add"]);
  }

  getDefaultDtSort(event: any) {
    if (event) {
      if (!event?.sortField || event?.sortField == "") {
        event.sortField = "srNo";
        event.sortOrder = "-1";
      }
    }
    return event;
  }

  loadPaperLazy(event: any = null) {
    this.loading = true;
    if (event !== null) {
      this.event = event;
    }
    this.event.customFilters = {};
    this.event = this.getDefaultDtSort(this.event);
    const body = {
      event: this.event,
    };
    this.globalFilter =
      event && event.globalFilter
        ? event.globalFilter
        : this.event.globalFilter;
    this.api.post(this.endpoint.getContact, body).subscribe(
      (result: any) => {
        this.users = [];
        this.resdata = result;
        if (this.resdata.status == "SUCCESS") {
          this.users = this.resdata.data.records;
          this.totalRecords = this.resdata.data.recordsTotal;
          this.loading = false;
        } else {
          this.loading = false;
        }
      },
      (error: any) => {
        this.users = [];
        this.loading = false;
        this.toast.setErrorPopupMessage(error?.error?.message);
      },
    );
  }

  showContactModalDialog(type: any, id: any, content: any) {
    if (type === "delete") {
      this.type = type;
      this.modelTitle = "Delete Contact";
      (this.modelMsg = "Are you sure you want to delete this contact"),
        {
          status: "Delete".toLowerCase(),
        };
      this.loading = false;
    } else {
      this.type = type;
      this.modelTitle =
        type === "deactivate" ? "Activate Contact" : "Deactivate Contact";
      this.modelMsg =
        type === "deactivate"
          ? "Are you sure you want to activate this contact?"
          : "Are you sure you want to deactivate this contact?";
      this.loading = false;
    }
    setTimeout(() => {
      this.modalService.open(content, {
        centered: true,
        size: "s",
        backdrop: "static",
        keyboard: false,
      });
    }, 500);
    this.deleteId = id;
  }
  deleteContactById() {
    this.loading = true;
    this.api
      .delete(this.endpoint.deleteContactByID + this.deleteId?.contactId)
      .subscribe(
        (result: any) => {
          this.resdata = result;
          if (this.resdata.status == "SUCCESS") {
            this.toast.setSuccessPopupMessage(result.message);
            this.loadPaperLazy();
          } else {
            this.toast.setErrorPopupMessage(this.resdata.message);
          }
          this.loading = false;
        },
        (error: any) => {
          this.loading = false;
          this.toast.setErrorPopupMessage(error?.error?.message);
        },
      );
  }
  activeDeactiveContact() {
    this.loading = true;
    let status = this.deleteId?.active ? "DEACTIVATE" : "ACTIVATE";
    const changeUserStatusEndPoint: any =
      this.endpoint.contactStatusChangeByID +
      this.deleteId.contactId +
      "/status/" +
      status;
    this.api.post(changeUserStatusEndPoint, "").subscribe(
      (result: any) => {
        this.resdata = result;
        if (this.resdata.status == "SUCCESS") {
          this.toast.setSuccessPopupMessage(result.message);
          this.loadPaperLazy();
        } else {
          this.toast.setErrorPopupMessage(this.resdata.message);
        }
        this.loading = false;
      },
      (error: any) => {
        this.loading = false;
        this.toast.setErrorPopupMessage(error?.error?.message);
      },
    );
  }
  onActions() {
    if (this.type == "delete") {
      this.deleteContactById();
    } else {
      this.activeDeactiveContact();
    }
  }
  editContactById(user: any) {
    this.router.navigateByUrl(`contact/${user.contactId}/edit`);
  }

  viewContactById(user: any) {
    this.api
      .get(this.endpoint.getContactByID + user.contactId)
      .subscribe((response: any) => {
        this.userData = response.data;
        this.id = user;
        const modalRef = this.modalService.open(ContactViewComponent, {
          size: "lg",
          centered: true,
        });
        modalRef.componentInstance.userData = response.data;
        modalRef.componentInstance.id = user;
      });
  }
  onImportContactPopUp() {
    this.addImportContactPopup = true;
  }
  setLoadingValue(event: any) {
    if (event && event == "SUCCESS") {
      this.addImportContactPopup = false;
      this.loadPaperLazy();
    }
    this.cdref.detectChanges();
  }
}
